import config from '../../config';
import { ChangeEvent } from 'react';

export const FormatDefaultValuePhoneNumber = function (number: string): string {
  if (!number || number.length == 0) {
    return '';
  }

  const numberClean = number.replace(/\D/g, '');

  if (numberClean.length < 4) {
    return '(' + numberClean;
  } else if (numberClean.length < 7) {
    return '(' + numberClean.substring(0, 3) + ') ' + numberClean.substring(3, 6);
  } else {
    return '(' + numberClean.substring(0, 3) + ') ' + numberClean.substring(3, 6) + '-' + numberClean.substring(6, 10);
  }
};

export const UnFormatValuePhoneNumber = function (number: string): string {
  return number.replace('(', '').replace(')', '').replace('-', '').replace(' ', '');
};

export const FormatDefaultFamiliplusCardValue = function (cardNumber: string): string {
  const cardStartingValue = config.CARD_STARTING_VALUE;
  if (!cardNumber || cardNumber.length == 0) {
    return '';
  }

  if (cardNumber.indexOf(cardStartingValue) > 1) {
    cardNumber = cardNumber.split(cardStartingValue)[1];
  }

  if (cardNumber.length < 4) {
    return cardNumber.substring(0, 3);
  } else if (cardNumber.length < 8) {
    return cardNumber.substring(0, 3) + '-' + cardNumber.substring(3, 7);
  } else if (cardNumber.length < 11) {
    return cardNumber.substring(0, 3) + '-' + cardNumber.substring(3, 7) + '-' + cardNumber.substring(7, 10);
  } else {
    return (
      cardNumber.substring(0, 3) +
      '-' +
      cardNumber.substring(3, 7) +
      '-' +
      cardNumber.substring(7, 10) +
      '-' +
      cardNumber.substring(10, 13)
    );
  }
};

const formatPhone = function (target: any): void {
  // Keep only digits
  let value = target.value.replace(/\D/g, '').substring(0, 10);
  // Based upon the length of the string, we add formatting as necessary
  const size = value.length;
  const currentAddedChar = target.value.match(/[\(\)\- ]/g)?.length || 0;
  let addedChar = 0;
  if (size > 0) {
    if (size < 4) {
      value = '(' + value;
      addedChar += 1;
    } else if (size < 7) {
      value = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6);
      addedChar += 3;
    } else {
      value = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + '-' + value.substring(6, 10);
      addedChar += 4;
    }
  }
  let pos = Math.max(target.selectionStart, target.selectionEnd) + (addedChar - currentAddedChar);
  if (pos == 1 || pos == 6 || pos == 10) {
    pos += 1;
  } else if (pos == 5) {
    pos += 2;
  } else if (pos <= 0 && addedChar > 0) {
    pos = 2;
  }
  target.value = value;
  target.selectionStart = pos;
  target.selectionEnd = pos;
};

export const onFormatPhoneChange = function (e: React.ChangeEvent, onChange?: (e: React.ChangeEvent) => void): void {
  formatPhone(e.target);
  if (onChange) {
    onChange(e);
  }
};

const formatCard = function (target: any): void {
  // Keep only digits
  let value = target.value.replace(/\D/g, '').substring(0, 13);
  // Based upon the length of the string, we add formatting as necessary
  const size = value.length;
  const currentAddedChar = target.value.match(/[\-]/g)?.length || 0;
  let addedChar = 0;
  if (size > 3) {
    if (size < 8) {
      value = value.substring(0, 3) + '-' + value.substring(3, 7);
      addedChar += 1;
    } else if (size < 11) {
      value = value.substring(0, 3) + '-' + value.substring(3, 7) + '-' + value.substring(7, 10);
      addedChar += 2;
    } else {
      value =
        value.substring(0, 3) +
        '-' +
        value.substring(3, 7) +
        '-' +
        value.substring(7, 10) +
        '-' +
        value.substring(10, 13);
      addedChar += 3;
    }
  }
  let pos = Math.max(target.selectionStart, target.selectionEnd) + (addedChar - currentAddedChar);
  if (pos == 4 || pos == 9 || pos == 13) {
    pos += 1;
  } else if ((pos == 3 || pos == 8) && addedChar < currentAddedChar) {
    pos += 2;
  } else if (pos <= 0) {
    pos = 1;
  }
  target.value = value;
  target.selectionStart = pos;
  target.selectionEnd = pos;
};

export const onFormatCardChange = function (e: React.ChangeEvent, onChange?: (e: React.ChangeEvent) => void): void {
  formatCard(e.target);
  if (onChange) {
    onChange(e);
  }
};

export const formatDateToISO = function (date: Date, timeIncluded = false): string {
  if (timeIncluded) {
    return date.toISOString();
  }
  return date.toISOString().split('T')[0];
};

export const formatPostalCodeValue = function (postalCode: string): string {
  if (postalCode.length !== 6) {
    return postalCode;
  }
  return postalCode.substring(0, 3) + ' ' + postalCode.substring(3);
};

export const unFormatPostalCodeValue = function (postalCode: string): string {
  return postalCode.replace(' ', '');
};

export const formatPostalCodeInput = function (target: EventTarget & HTMLInputElement): void {
  // Keep only digits and letters
  let value = target.value.replace(/\W/g, '').substring(0, 6);
  // Based upon the length of the string, we add formatting as necessary
  const size = value.length;

  const currentAddedChars = target.value.indexOf(' ') > -1 ? 1 : 0;
  let addedChars = 0;
  if (size > 3) {
    value = value.substring(0, 3) + ' ' + value.substring(3);
    addedChars += 1;
  }

  let pos = Math.max(target.selectionStart || 0, target.selectionEnd || 0) + (addedChars - currentAddedChars);
  if (pos < 0) {
    pos = 0;
  }

  target.value = value;
  target.selectionStart = pos;
  target.selectionEnd = pos;
};

export const onPostalCodeChange = function (
  e: ChangeEvent<HTMLInputElement>,
  onChange: (e: ChangeEvent) => void
): void {
  formatPostalCodeInput(e.target);
  onChange(e);
};

const formatNumber = function (target: any): void {
  // Keep only digits
  target.value = target.value.replace(/\D/g, '');
};

export const onFormatNumberChange = function (e: React.ChangeEvent, onChange?: (e: React.ChangeEvent) => void): void {
  formatNumber(e.target);
  if (onChange) {
    onChange(e);
  }
};
